export default {
	subtitle: "",
	path: "webhooks_subscription_qr_code_generated",
	paragraphs: [
		"This notification is send when the QR Code is generated for a subscription.",
	],
	request: {
		method: "POST",
		payloads: [
			{
				title: "Notification",
				content: {
					"notification": {
						"secret": "the value you received",
						"type": "subscription_qr_code_generated",
						"subscription": {
							"id": "d5dbfff5-7391-447b-a642-a57af80b09db",
							"status": "pending",
							"subject_id": "7c6afdd6-eb4b-4113-93c6-95be304ea9cc",
							"subscription_id": "991740dd-d1d3-4f80-81ad-7062388aaedc",
							"qr_code": "00020126580014br.gov.bcb.pix0136123e4567-e89b-12d3-a456-426614174000520400005303986540510.005802BR5913FACILITA PAY6008BRASILIA62070503***63041D3D"
						},
					}
				}
			}
		]
	}
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/WebHook/NotificationSubscriptionInvoiceQRCodeGenerated.js